// extracted by mini-css-extract-plugin
module.exports = {"summary":"OversiktFiltersSummary_summary__CZfHO","nohits":"OversiktFiltersSummary_nohits__VhgxO"};